import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';

import { REGEX_SHORT_URL_ID } from '../../../../../../../common/helpers';
import { selectBandwidthEffective4kCodecExp } from '../../../user/selectors';

export const useShouldShowBandwidthTumbler = () => {
    const bandwidthEffective4kCodecExp = useSelector(selectBandwidthEffective4kCodecExp);
    const { pathname } = useLocation();
    const isOnCallPage = REGEX_SHORT_URL_ID.test(pathname);

    return bandwidthEffective4kCodecExp && !isOnCallPage;
};
